import { noddiAsync, URLKeys } from 'noddi-async';
import { useAuthContext, useShouldFireRequestForLoggedInUser } from 'noddi-web';
import { membershipProgramImages } from '../utils/checkoutDiscounts';

/**
 * Low-stakes: checkout still renders if the logo lookup fails.
 * `userGroupId` is the group the checkout prices for (a proposal's); defaults to the selected one.
 */
export const useMembershipProgramImages = (userGroupId?: number) => {
  const { currentUserGroupId } = useAuthContext();
  const logoUserGroupId = userGroupId ?? currentUserGroupId;
  const shouldFetch = useShouldFireRequestForLoggedInUser();

  const { data: membershipPrograms, error: _membershipProgramsError } = noddiAsync.useGet({
    type: URLKeys.getMembershipProgramsForUserGroup,
    input: { userGroupId: logoUserGroupId! },
    queryConfig: {
      enabled: shouldFetch
    }
  });

  return membershipProgramImages(membershipPrograms);
};
